import { createIntl } from "react-intl";
/**
 * Mocks the strictLocalize function. Returns the defaultMessage passed in the descriptor.
 */ export var mockStrictLocalize = function(descriptor, values, opts) {
    return createIntl({
        locale: "en"
    }).formatMessage(descriptor, values, opts);
};
